'use strict';

window.slidePositionVieved = window.slidePositionVieved || {};
window.statElementCollector = window.statElementCollector || {};

for (const gallery of document.querySelectorAll('.gallery_hover')) {
	var wrapper = gallery.closest('.__js_stats_wrapper');
	var artID = wrapper ? wrapper.dataset.id : undefined;
	var ga360id = gallery.dataset.ga360Id;

	if (!ga360id) {
		console.log(
			'%c dodać ga360-id do Galerii hover: ' + (gallery.dataset.id || ''),
			'background: #553311; padding: 3px; color: #ffaaaa'
		);
		continue;
	}

	statElementCollector[ga360id + '-' + artID] = {
		id: ga360id,
		moduleName: gallery.dataset.id,
		viewedCount: 0,
		itemCount: gallery.querySelectorAll('.gallery_hover__item').length
	};

	slidePositionVieved[ga360id + '-' + artID] = {};
}

function itemHover(item) {
	var gallery = item.closest('.gallery_hover');
	var wrapper = item.closest('.__js_stats_wrapper');
	var artID = wrapper ? wrapper.dataset.id : undefined;
	var galID = gallery ? gallery.dataset.id : undefined;
	var ga360id = gallery ? gallery.dataset.ga360Id : undefined;
	var imgEl = item.querySelector('.gallery_hover__img');
	var imgID = imgEl ? imgEl.getAttribute('src') : undefined;
	var elId = item.dataset.item;

	item.classList.add('__jsActive');
	setTimeout(function () {
		var arrow = item.querySelector('.gallery_hover__arrow');
		if (arrow) arrow.classList.add('tapped');
	}, 500);

	if (window.isScrolling) return;
	if (!ga360id) return;

	var key = ga360id + '-' + artID;
	if (!slidePositionVieved[key]) slidePositionVieved[key] = {};

	var siblings = item.parentNode ? item.parentNode.children : [];
	var activeIndex = -1;
	for (var i = 0; i < siblings.length; i++) {
		if (siblings[i] === item) {
			activeIndex = i;
			break;
		}
	}
	if (activeIndex > -1) slidePositionVieved[key][activeIndex] = 1;

	if (statElementCollector[key]) {
		statElementCollector[key].viewedCount = Object.keys(slidePositionVieved[key]).length;
	}

	if (typeof sendStats === 'function') {
		sendStats('gallery', 'hover-' + elId, artID + ' / ' + galID, imgID);
	}

	if (typeof isScrolligFlag === 'undefined' || !isScrolligFlag) {
		window.dataLayer.push({
			event: 'content_interaction',
			eventCategory: ga360id,
			moduleName: galID,
			eventAction: window.deviceTouch ? 'tap' : 'hover'
		});


	}
}

var eventName = window.deviceTouch ? 'click' : 'mouseover';

for (const container of document.querySelectorAll('.gallery_hover')) {
	container.addEventListener(eventName, function (e) {
		var item = e.target.closest('.gallery_hover__item');
		if (!item || !container.contains(item)) return;
		if (eventName === 'mouseover') {
			var from = e.relatedTarget;
			if (from && item.contains(from)) return;
		}
		itemHover(item);
	});

	for (const it of container.querySelectorAll('.gallery_hover__item')) {
		it.addEventListener('mouseleave', function () {
			it.classList.remove('__jsActive');
			var arrow = it.querySelector('.gallery_hover__arrow');
			if (arrow) arrow.classList.remove('tapped');
		});
	}
}

for (const el of document.querySelectorAll('.gallery_hover__arrow')) {
	el.addEventListener('click', function (ev) {
		ev.stopPropagation();
		var parent = el.closest('.gallery_hover__item');
		if (el.classList.contains('tapped')) {
			if (parent) parent.classList.remove('__jsActive');
			el.classList.remove('tapped');
		} else if (parent) {
			itemHover(parent);
		}
	});
}